export default "__VITE_ASSET__DAHWU666__"